import { render } from "./TournamentPlayer.vue?vue&type=template&id=6ff56b9c"
import script from "./TournamentPlayer.vue?vue&type=script&lang=js"
export * from "./TournamentPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__